import { useEffect, useMemo, useState } from "react";
import { Eye, Download } from "lucide-react";
import { api } from "@/lib/api";
import { Panel, NativeSelect, Empty } from "@/components/crm/common";
import { DataTable } from "@/components/crm/DataTable";
import { PreviewDialog, canPreview, fetchBlob, download } from "@/components/crm/Files";

const TYPE = { project: "Project file", task: "Work file", approval: "Approval file", vendor_expense: "Vendor bill" };

export function ProjectFiles() {
  const [rows, setRows] = useState(null);
  const [pid, setPid] = useState("");
  const [type, setType] = useState("");
  const [q, setQ] = useState("");
  const [preview, setPreview] = useState(null);
  useEffect(() => { api.get("/hub/files").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const projects = useMemo(() => [...new Map((rows || []).map((f) => [f.project_id, f.project_name])).entries()].map(([value, label]) => ({ value, label })), [rows]);
  if (!rows) return <Panel><Empty text="Loading…" /></Panel>;
  const list = rows.filter((f) => (!pid || f.project_id === pid) && (!type || f.entity_type === type) && (!q || `${f.original_filename} ${f.context} ${f.uploaded_by}`.toLowerCase().includes(q.toLowerCase())));
  return (
    <Panel testid="project-files" title={`Project & work files (${list.length})`}>
      <div className="mb-3 flex flex-wrap gap-2">
        <input data-testid="files-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search file, task or uploader" className="h-9 w-64 rounded-lg border px-3 text-sm outline-none" />
        <NativeSelect testid="files-project-filter" value={pid} onChange={setPid} placeholder="All projects" options={projects} />
        <NativeSelect testid="files-type-filter" value={type} onChange={setType} placeholder="All file types" options={Object.entries(TYPE).map(([value, label]) => ({ value, label }))} />
      </div>
      <DataTable testid="files-table" rows={list} columns={[
        { key: "original_filename", label: "File", render: (f) => <span className="font-bold">{f.original_filename}</span> },
        { key: "project_name", label: "Project" }, { key: "entity_type", label: "Type", render: (f) => TYPE[f.entity_type] }, { key: "context", label: "Task / item" },
        { key: "uploaded_by", label: "Uploaded by" }, { key: "created_at", label: "Date", render: (f) => (f.created_at || "").slice(0, 10) },
        { key: "act", label: "", render: (f) => <div className="flex">
          {canPreview(f) && <button data-testid={`file-preview-${f.id.slice(0, 6)}`} onClick={() => setPreview(f)} className="p-1.5 text-zinc-400 hover:text-[#C5A46D]"><Eye className="h-4 w-4" /></button>}
          <button data-testid={`file-download-${f.id.slice(0, 6)}`} onClick={async () => download(await fetchBlob(f), f.original_filename)} className="p-1.5 text-zinc-400 hover:text-[#C5A46D]"><Download className="h-4 w-4" /></button></div> },
      ]} />
      <PreviewDialog file={preview} onClose={() => setPreview(null)} />
    </Panel>
  );
}
